import React from "react";
import Chapter from "@/components/landing/Chapter";
import Reveal from "@/components/landing/Reveal";

const pillars = [
  {
    n: "01",
    title: "Alta negociación",
    text: "Para cerrar acuerdos, defender tu valor y tomar decisiones comerciales con mayor seguridad.",
  },
  {
    n: "02",
    title: "Relacionamiento estratégico",
    text: "Para construir alianzas que abran oportunidades reales de negocio, visibilidad e influencia.",
  },
  {
    n: "03",
    title: "Comunicación en público",
    text: "Para hablar ante medios, audiencias y entornos profesionales con presencia, claridad y autoridad.",
  },
  {
    n: "04",
    title: "Eficiencia en la gestión",
    text: "Para optimizar tiempo, recursos, procesos y decisiones como líder.",
  },
];

const Experience = () => {
  return (
    <section
      id="experiencia"
      data-testid="experience-section"
      className="bg-[#F4EFE7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 lg:py-40">
        <div className="max-w-4xl">
          <Reveal>
            <Chapter number="05" label="La jornada — 15 de octubre" />
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#3F403A]">
              Una jornada intensiva para{" "}
              <span className="italic text-[#63846F]">pensar, decidir y liderar</span>{" "}
              de otra manera.
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-8 md:mt-10 font-sans text-base md:text-lg leading-relaxed text-[#3F403A]/85 max-w-3xl">
              Durante la jornada presencial trabajaremos sobre cuatro grandes
              áreas que hoy son esenciales para cualquier mujer que lidera un
              negocio, un equipo o una marca con vocación de crecimiento.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#3F403A]/12">
          {pillars.map((p, i) => (
            <Reveal
              key={p.n}
              delay={i * 100}
              className="bg-[#F4EFE7] p-8 md:p-12 lg:p-14 group"
              data-testid={`experience-pillar-${i}`}
            >
              <div className="flex items-start justify-between mb-8">
                <span className="overline text-[#63846F]">{p.n}</span>
                <span className="h-px w-14 bg-[#3F403A]/25 mt-3" />
              </div>
              <h3 className="font-serif text-3xl md:text-4xl text-[#3F403A] leading-tight group-hover:text-[#63846F] transition-colors">
                {p.title}
              </h3>
              <p className="mt-6 font-sans text-base leading-relaxed text-[#3F403A]/80">
                {p.text}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
